export default {"src":"/_next/static/media/NEE.7b08ce5d.svg","height":18,"width":18};